const initialState = {
  list: [],
  type: 'Active',
  typeFilter: 'Active',
  selected: {},
  selectedMember: {},
  members: [],
  pageType: 'list',
  actionItem: null,
  activeStatus: [],
  Count: {},
  filters: {},
  selectedTaskFilters: [],
  selectedFilters: [],
  sorting: {
    column: 'workstream',
    order: 'asc',
  },
  searchedIndex: 0,
  searchedQuery: '',
  searchWorkstream: false,
  hasChanges: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_WORKSTREAMS_CHANGES':
      return {
        ...state,
        hasChanges: action.boolean,
      };

    case 'UPDATE_WORKSTREAMS_LIST':
      return {
        ...state,
        list: action.list,
      };

    case 'UPDATE_WORKSTREAMS_LIST_FILTER':
      return {
        ...state,
        typeFilter: action.typeFilter,
      };

    case 'REMOVE_WORKSTREAMS_ITEM':
      return {
        ...state,
        list: state.list.filter((w) => w.id !== action.id),
      };

    case 'UPDATE_WORKSTREAMS_TYPE':
      return {
        ...state,
        type: action.workstreamType,
      };

    case 'UPDATE_WORKSTREAMS_SELECTED':
      return {
        ...state,
        selected: action.selected,
      };

    case 'UPDATE_WORKSTREAMS_MEMBERS':
      return {
        ...state,
        members: action.members,
      };

    case 'UPDATE_WORKSTREAMS_PAGE_TYPE':
      return {
        ...state,
        pageType: action.pageType,
      };

    case 'UPDATE_WORKSTREAMS_SELECTED_MEMBER':
      return {
        ...state,
        selectedMember: action.member,
      };
    case 'UPDATE_WORKSTREAMS_COUNT':
      return {
        ...state,
        Count: action.count,
      };
    case 'SET_WORKSTREAM_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.column]: action.filters,
        },
      };
    case 'SET_WORKSTREAM_SELECTED_TASK_FILTERS':
      return {
        ...state,
        selectedTaskFilters: action.selectedTaskFilters,
      };
    case 'SET_WORKSTREAM_SELECTED_FILTERS':
      return {
        ...state,
        selectedFilters: action.selectedFilters,
      };
    case 'SET_WORKSTREAM_SORTING':
      return {
        ...state,
        sorting: action.sorting,
      };
    case 'SET_WORKSTREAM_ACTIVE_STATUS':
      return {
        ...state,
        activeStatus: action.status,
      };
    case 'UPDATE_WORKSTREAM_SEARCHED_INDEX':
      return {
        ...state,
        searchedIndex: action.index,
      };
    case 'UPDATE_WORKSTREAM_SEARCHED_INDEX':
      return {
        ...state,
        searchedIndex: action.index,
      };

    case 'UPDATE_WORKSTREAM_SEARCHED_QUERY':
      return {
        ...state,
        searchedQuery: action.query,
      };
    case 'UPDATE_WORKSTREAM_SEARCH':
      return {
        ...state,
        searchedQuery: action.query,
        searchedIndex: action.index,
      };
    case 'SET_WORKSTREAM_SEARCH_TOGGLE':
      return {
        ...state,
        searchWorkstream: action.enabled,
      };
    default:
      return state;
  }
}
